// extracted by css-extract-rspack-plugin
export default {"nav":"alfEq"};